import { render, staticRenderFns } from "./functionStateDetail.vue?vue&type=template&id=96d0a646&scoped=true"
import script from "./functionStateDetail.vue?vue&type=script&lang=js"
export * from "./functionStateDetail.vue?vue&type=script&lang=js"
import style0 from "./functionStateDetail.vue?vue&type=style&index=0&id=96d0a646&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96d0a646",
  null
  
)

export default component.exports